import { ComparisonTableRow } from './Table';

export const getHeaders = (data: ComparisonTableRow[]) => {
  const headers: string[] = [];

  data.forEach((row) => {
    Object.keys(row.values).forEach((key) => {
      if (!headers.includes(key)) {
        headers.push(key);
      }
    });
  });

  return headers;
};
